<template>
  <div class="row">
    <div class="col">
      <v-card>
        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="selection = index"
          >
            <v-list-item-title>
              <a :href="item.value" target="_blank">{{ item.title }} </a>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
    <div class="col"></div>
  </div>
</template>
<script>
export default {
  name: "ExternalLinks",
  data: () => ({
    selection: 0,
    items: [
      { title: "Zoho Subcriptions", value: "https://subscriptions.zoho.com" },
      { title: "Zoho Commerce", value: "https://www.zoho.com/commerce" },
      { title: "BiblioTech Global", value: "https://www.etbn.global" },
      { title: "BiblioTech Books", value: "https://books.etbn.online/" },
    ],
  }),
};
</script>



// WEBPACK FOOTER //
// src/views/ExternalLinks.vue